var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',{staticClass:"strong-label",class:{
    'strong-label--small': _vm.size === 'small',
    'strong-label--large': _vm.size === 'large',
    'strong-label--danger': _vm.kind === 'danger',
    'strong-label--success': _vm.kind === 'success',
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }